/**
 * Suggested Questions — שאלות מוצעות
 *
 * The core answer to "students don't know what to ask": each chip is an authored
 * question the student can send with one click. The chips are static strings that
 * ship with the lesson, so offering them costs nothing — only the answer does.
 */

import { MessageCircleQuestion } from 'lucide-react'

interface SuggestedQuestionsProps {
  questions: string[]
  used: string[]
  disabled?: boolean
  onPick: (question: string) => void
}

export default function SuggestedQuestions({
  questions,
  used,
  disabled = false,
  onPick,
}: SuggestedQuestionsProps) {
  const available = questions.filter((q) => !used.includes(q))
  if (available.length === 0) return null

  return (
    <section aria-labelledby="suggested-questions-heading" className="px-4 py-3">
      <h3
        id="suggested-questions-heading"
        className="flex items-center gap-1.5 text-xs font-semibold text-gray-700"
      >
        <MessageCircleQuestion size={14} aria-hidden="true" />
        לא בטוח/ה מה לשאול? נסה/י אחת מאלה
      </h3>
      <ul className="mt-2 flex flex-wrap gap-2">
        {available.map((q) => (
          <li key={q}>
            <button
              type="button"
              onClick={() => onPick(q)}
              disabled={disabled}
              className="rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs text-primary-800 transition-colors hover:bg-primary-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {q}
            </button>
          </li>
        ))}
      </ul>
    </section>
  )
}
